import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.scss';

export const Dropdown = ({
    items,
    selectedValue,
    setSelectedValue,
    className = '',
    buttonClassName = '',
    menuClassName = '',
    itemClassName = '',
    disabled = false,
    icon,
    arrow,
    placeholder = '',
    valueKey = 'value',
    labelKey = 'label',
    formik,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (value) => {
        setSelectedValue(value);
        setIsOpen(false);
        formik?.setFieldValue('order_type_id', value.id);
    };

    const toggleDropdown = () => {
        if (!disabled) setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <div className={`${className}`} ref={dropdownRef}>
            <button
                type="button"
                className={`${buttonClassName} ${disabled ? 'btn-disabled' : ''} ${isOpen ? 'dropdown-open' : ''} `}
                onClick={toggleDropdown}
            >
                <div className="dropdown-label">
                    {icon && <span className="dropdown-icon">{icon}</span>}
                    <span>{selectedValue ? selectedValue[labelKey] : placeholder}</span>
                </div>
                <span className={`dropdown__svg ${!isOpen ? 'dropdown__svg--up' : 'dropdown__svg--down'}`}>
                    {arrow}
                </span>
            </button>

            {isOpen && (
                <ul className={`${menuClassName}`}>
                    {items.map((item) => (
                        <li
                            key={item[valueKey]}
                            className={`${itemClassName} ${selectedValue === item[valueKey] ? 'selected' : ''}`}
                            onClick={() => handleSelect(item)}
                        >
                            {item[labelKey]}
                        </li>
                    ))}
                </ul>
            )}
            {formik.errors.order_type_id && formik.touched.order_type_id && (
                <div className="error-message">
                    {formik.errors.order_type_id}
                </div>
            )}
        </div>
    );
};